import { _ as _slicedToArray, b as _objectSpread2 } from './_rollupPluginBabelHelpers-53ddb3bb.js';
var rootVal = 10;
var preferredUnit = 'rem'; // Base sizing

var space = [0, 4, 8, 16, 32, 64, 128, 256, 512];
space.xxxs = space[0];
space.xxs = space[1];
space.xs = space[2];
space.sm = space[3];
space.md = space[4];
space.lg = space[5];
space.xl = space[6];
space.xxl = space[7];
space.xxxl = space[8];
var fonts = {
  body: 'system-ui, sans-serif',
  heading: 'inherit',
  monospace: 'Menlo, monospace'
};
var fontSizes = [12, 14, 16, 20, 24, 32, 48, 64, 96];
fontSizes.xs = fontSizes[0];
fontSizes.sm = fontSizes[1];
fontSizes.base = fontSizes[2];
fontSizes.md = fontSizes[3];
fontSizes.lg = fontSizes[4];
fontSizes.xl = fontSizes[5];
fontSizes.xxl = fontSizes[6];
fontSizes.title = fontSizes[7];
fontSizes.display = fontSizes[8];
var fontWeights = [100, 200, 300, 400, 500, 600, 700, 800, 900];
fontWeights.hairline = fontWeights[0];
fontWeights.thin = fontWeights[1];
fontWeights.light = fontWeights[2];
fontWeights.regular = fontWeights[3];
fontWeights.medium = fontWeights[4];
fontWeights.semibold = fontWeights[5];
fontWeights.bold = fontWeights[6];
fontWeights.extrabold = fontWeights[7];
fontWeights.black = fontWeights[8];
fontWeights.body = fontWeights.regular;
fontWeights.heading = fontWeights.bold;
fontWeights.display = fontWeights.black;
var grey = ['#F1F1F1', '#D5DCE1', '#B7C2CC', '#93A1B0', '#748494', '#556575', '#314351', '#253642', '#1d2b36'];
var primary = ['#fff4e6', '#ffe8cc', '#ffd8a8', '#ffc078', '#ffa94d', '#ff922b', '#fd7e14', '#f76707', '#e8590c', '#d9480f'];
var secondary = ['#e3fafc', '#c5f6fa', '#99e9f2', '#66d9e8', '#3bc9db', '#22b8cf', '#15aabf', '#1098ad', '#0c8599', '#0b7285'];
var success = ['#ebfbee', '#d3f9d8', '#b2f2bb', '#8ce99a', '#69db7c', '#51cf66', '#40c057', '#37b24d', '#2f9e44', '#2b8a3e'];
var warning = ['#fff9db', '#fff3bf', '#ffec99', '#ffe066', '#ffd43b', '#fcc419', '#fab005', '#f59f00', '#f08c00', '#e67700'];
var error = ['#fff5f5', '#ffe3e3', '#ffc9c9', '#ffa8a8', '#ff8787', '#ff6b6b', '#fa5252', '#f03e3e', '#e03131', '#c92a2a'];
var foreground = grey[7];
var background = grey[0];
var colors = {
  primary: primary,
  secondary: secondary,
  success: success,
  error: error,
  warning: warning,
  grey: grey,
  foreground: foreground,
  background: background
};
var widths = [440, 730, 950, 1200, 1400];
widths.xs = widths[0];
widths.sm = widths[1];
widths.md = widths[2];
widths.lg = widths[3];
widths.xl = widths[4];
var breakpoints = [480, 768, 992, 1226, 1440];
var _breakpoints = breakpoints;

var _breakpoints2 = _slicedToArray(_breakpoints, 5);

breakpoints.xs = _breakpoints2[0];
breakpoints.sm = _breakpoints2[1];
breakpoints.md = _breakpoints2[2];
breakpoints.lg = _breakpoints2[3];
breakpoints.xl = _breakpoints2[4];
var borderWidths = [1, 2, 3, 4, 8];
borderWidths.xs = borderWidths[0];
borderWidths.sm = borderWidths[1];
borderWidths.md = borderWidths[2];
borderWidths.lg = borderWidths[3];
borderWidths.xl = borderWidths[4];
var borders = ["".concat(borderWidths.xs, "px solid ").concat(colors.grey[4]), "".concat(borderWidths.xs, "px solid ").concat(colors.primary[4]), "".concat(borderWidths.xs, "px solid ").concat(colors.secondary[4]), "".concat(borderWidths.xs, "px solid ").concat(colors.success[4]), "".concat(borderWidths.xs, "px solid ").concat(colors.warning[4]), "".concat(borderWidths.xs, "px solid ").concat(colors.error[4])];
borders.grey = borders[0];
borders.primary = borders[1];
borders.secondary = borders[2];
borders.success = borders[3];
borders.warning = borders[4];
borders.error = borders[5];
borders.separator = borders.grey;
borders.thin = borders.grey;
var borderStyles = ['solid', 'dashed', 'dotted'];
var radii = [3, 5, 7, 20];
radii.sm = radii[0];
radii.md = radii[1];
radii.lg = radii[2];
radii.pill = radii[3];
radii.circle = 50;
var lineHeights = {
  body: 1.5,
  heading: 1.125
};
var zIndices = [-10, 0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
var shadows = ['none', '0px 1px 3px rgba(0, 0, 0, 0.1)', '0px 2px 4px rgba(0, 0, 0, 0.15)', '0px 2px 7px rgba(0, 0, 0, 0.15)', '0px 2px 10px rgba(0, 0, 0, 0.2)'];
shadows.none = shadows[0];
shadows.sm = shadows[1];
shadows.md = shadows[2];
shadows.lg = shadows[3];
shadows.xl = shadows[4];
var elevations = shadows;
var headingStyle = {
  fontFamily: fonts.heading,
  fontWeight: fontWeights.heading
};
var fontStyles = {
  title: _objectSpread2({
    fontSize: fontSizes.title
  }, headingStyle),
  subtitle: _objectSpread2({
    fontSize: fontSizes.xxl
  }, headingStyle),
  sectionTitle: _objectSpread2({
    fontSize: fontSizes.xl
  }, headingStyle)
};
var Theme = {
  preferredUnit: preferredUnit,
  rootVal: rootVal,
  fonts: fonts,
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  lineHeights: lineHeights,
  colors: colors,
  widths: widths,
  breakpoints: breakpoints,
  borders: borders,
  borderWidths: borderWidths,
  borderStyles: borderStyles,
  radii: radii,
  zIndices: zIndices,
  shadows: shadows,
  elevations: elevations,
  space: space,
  variants: _objectSpread2({}, fontStyles)
};
export default Theme;
export { Theme };